/* A LITTLE CHRISTMAS page (2026-10-15). Copy of gb-a-la-carte.js with its own basket key
   (gb_xmas_cart_v1) + Christmas extras at the end. Editing this file does NOT change A La Carte. */
(function(){

  /* 2026-10-22: the basket is the SHARED cart (gb-cart.js, "gb_cart_v1"), the same on every page.
     selectedItems = every single piece in that cart (also pieces added on other pages);
     PAGE_SRC marks the pieces added on this page. The old basket "gb_xmas_cart_v1" is moved into it once. */
  var PAGE_SRC = 'xmas';
  var LEGACY_KEY = 'gb_xmas_cart_v1';
  var selectedItems = {};
  var catGroups = {};
  var lbCard = null;
  var lbImages = [];
  var lbSizes = [];
  var lbSize = null;
  var toastTimer = null;
  var currentTabIndex = 0;
  var lbCurrentQty = 1;
  var lbMaxQty = 999;

  GBCart.importLegacy(LEGACY_KEY, PAGE_SRC, location.pathname);
  selectedItems = GBCart.pieceMap();

  function saveCart() { GBCart.syncPieces(selectedItems); }
  function mine(item) { return !item.src || item.src === PAGE_SRC; }

  var getEl = function(id){ return document.getElementById(id); };
  function esc(s){ return String(s || "").replace(/"/g, "&quot;"); }
  function escHTML(s){ return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"); }

  /* Per-variant stock: Shopify products.json "available" + the INVENTORY_DATA map rendered by Liquid above. */
  function variantStock(v){
    var maxQty = 999, outOfStock = v.available === false;
    var stock = rawStock(v.id);
    if (stock != null) {
      /* 2026-10-22: minus what the shared cart already holds in OTHER lines (gift-set picks), so the last one
         can't be ordered twice; this page's own piece doesn't count against itself */
      maxQty = Math.max(0, stock - usedElsewhere(v.id));
      if (maxQty === 0) outOfStock = true;
    }
    return { maxQty: maxQty, outOfStock: outOfStock };
  }
  /* The shop's stock number of a variant, or null when it isn't limited. */
  function rawStock(id){
    var inv = (window.INVENTORY_DATA || {})[id];
    return inv && inv.m === "shopify" && inv.p === "deny" ? (inv.q > 0 ? inv.q : 0) : null;
  }
  function usedElsewhere(id){
    var own = selectedItems[id] ? selectedItems[id].quantity : 0;
    return Math.max(0, GBCart.usedQty(id) - own);
  }
  /* Size variants. A product with no size options has a single "Default Title" variant -> []. */
  function getSizes(p){
    var vs = p.variants || [];
    if (vs.length <= 1 && (!vs[0] || vs[0].title === "Default Title")) return [];
    return vs.map(function(v){
      var st = variantStock(v);
      return { id: String(v.id), title: v.title, price: v.price ? formatPrice(v.price) : "0.00", maxQty: st.maxQty, available: !st.outOfStock };
    });
  }
  /* No Size variants? Fall back to the sizes typed in the "Size" category metafield (display only, not pickable). */
  function metaSizesHTML(p){
    var labels = (window.GB_SIZE_LABELS || {})[p.id] || [];
    if (!labels.length) return '';
    return '<p class="hb-card-sizes"><span class="hb-card-sizes-lbl">' + (labels.length > 1 ? ALC_STRINGS.sizes_label : ALC_STRINGS.size_label) + ':</span> '
      + labels.map(function(t){ return '<span class="hb-card-size">' + escHTML(t) + '</span>'; }).join('')
      + '</p>';
  }
  function displayName(sel){
    return sel.size ? sel.name + " \u2014 " + ALC_STRINGS.size_label + " " + sel.size : sel.name;
  }
  function formatPrice(price) { return parseFloat(price).toFixed(2); }

  /* Totals of the whole shared cart (pieces + gift sets). Delivery rule lives in gb-cart.js:
     free with any gift set or from AED 200, otherwise AED 25. */
  function getSubtotal() { return GBCart.totals().subtotal; }
  function getDeliveryCharge() { return GBCart.totals().delivery; }
  function getTotalItemsCount() { return GBCart.totals().count; }

  /* Ask Shopify's CDN for a resized image instead of the full-size original. */
  function imgW(u, w){
    if (!/(^|\/\/)cdn\.shopify\.com\/|\/cdn\/shop\//.test(u)) return u;
    u = u.replace(/([?&])width=\d+(&|$)/, function(m, a, b){ return b ? a : ""; });
    return u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
  }
  /* 2026-10-23: card photos in the size the screen needs (cards are ~150-180px wide on phones,
     ~360px on tablets, <=280px on computers) instead of always 600px: about half the data on phones. */
  var GB_CARD_SIZES = "(max-width: 960px) 47vw, 280px";
  function imgSet(u){ return [240, 360, 480, 600].map(function(w){ return imgW(u, w) + " " + w + "w"; }).join(", "); }
  function getImages(p){
    var imgs = (p.images || []).map(function(i){ return imgW(i.src || i, 1200); }).filter(Boolean);
    if (!imgs.length && p.image && p.image.src) imgs = [imgW(p.image.src, 1200)];
    if (!imgs.length) imgs = ["https://placehold.co/800x800/f7f3ee/c9a96e?text=Product"];
    return imgs;
  }


  // A category is made of one or more groups; each group merges one or more collections
  // (deduped by product id) and renders under an optional sub-heading.

  function cardHTML(prod, catKey, catName){
    var v = prod.variants[0];
    var imgs = getImages(prod);
    var sizes = getSizes(prod);
    var st = variantStock(v);
    var maxQty = st.maxQty;
    var picked = sizes.length
      ? sizes.some(function(sz){ return !!selectedItems[sz.id]; })
      : !!selectedItems[v.id];
    var outOfStock = sizes.length
      ? !sizes.some(function(sz){ return sz.available; })
      : st.outOfStock;
    var displayPrice = v.price ? formatPrice(v.price) : "0.00";
    var priceFrom = false;
    if (sizes.length) {
      var prices = sizes.map(function(sz){ return parseFloat(sz.price); });
      var lo = Math.min.apply(null, prices), hi = Math.max.apply(null, prices);
      displayPrice = formatPrice(lo); priceFrom = hi > lo;
    }
    var sizesHTML = sizes.length
      ? '<p class="hb-card-sizes"><span class="hb-card-sizes-lbl">' + ALC_STRINGS.sizes_label + ':</span> '
        + sizes.map(function(sz){ return '<span class="hb-card-size' + (sz.available ? '' : ' hb-card-size-oos') + '">' + escHTML(sz.title) + '</span>'; }).join('')
        + '</p>'
      : metaSizesHTML(prod);
    return '<button type="button" class="hb-card' + (picked ? ' hb-picked' : '') + (outOfStock ? ' hb-oos' : '') + '"'
      + ' data-cat="' + catKey + '" data-catname="' + esc(catName) + '"'
      + ' data-variant="' + v.id + '" data-product="' + prod.id + '" data-sizes="' + encodeURIComponent(JSON.stringify(sizes)) + '"'
      + ' data-maxqty="' + maxQty + '"'
      + ' data-price="' + displayPrice + '"'
      + ' data-name="' + esc(prod.title) + '"'
      + ' data-handle="' + esc(prod.handle) + '"'
      + ' data-desc="' + esc((prod.body_html || '').replace(/<[^>]*>/g, '').substring(0, 300)) + '"'
      + ' data-thumb="' + imgs[0] + '"'
      + ' data-images="' + encodeURIComponent(JSON.stringify(imgs)) + '"'
      + ' onclick="window.openLB(this)">'
      + '<div class="hb-card-media"><img src="' + imgW(imgs[0], 600) + '" srcset="' + imgSet(imgs[0]) + '" sizes="' + GB_CARD_SIZES + '" alt="' + esc(prod.title) + '" width="800" height="800" loading="lazy"/>'
      + (imgs.length > 1 ? '<div class="hb-card-badge">' + imgs.length + ' ' + ALC_STRINGS.photos_badge + '</div>' : '')
      + (outOfStock ? '<div class="hb-oos-badge">' + ALC_STRINGS.out_of_stock + '</div>' : '')
      + (picked ? '<div class="hb-card-sel"><span class="hb-card-sel-check">&#10003;</span> ' + ALC_STRINGS.added_badge + '</div>' : '')
      + '</div>'
      + '<div class="hb-card-info">'
      + '<p class="hb-card-name">' + prod.title + '</p>'
      + sizesHTML
      + '<p class="hb-card-price">' + (priceFrom ? ALC_STRINGS.from_price + ' ' : '') + 'AED ' + displayPrice + '</p>'
      + '</div>'
      + '</button>';
  }

  // Render every group inside a category: an optional serif sub-heading, then its grid.
  function groupsHTML(groups, key, catName){
    return groups.map(function(g){
      var grid = (g.products && g.products.length)
        ? '<div class="hb-grid">' + g.products.map(function(p){ return cardHTML(p, key, catName); }).join("") + '</div>'
        : '<p class="hb-empty">' + ALC_STRINGS.no_products + '</p>';
      var head = g.name
        ? '<div class="hb-group-head"><span class="hb-group-title">' + g.name + '</span></div>'
        : '';
      return '<div class="hb-group">' + head + grid + '</div>';
    }).join("");
  }

  function sectionHTML(cat, groups, i){
    var key = "c" + i;
    var selCount = Object.values(selectedItems).filter(function(item) { return mine(item) && item.catKey === key; }).reduce(function(sum, item) { return sum + item.quantity; }, 0);
    var pillText = selCount > 0 ? selCount + ' ' + ALC_STRINGS.items_selected : ALC_STRINGS.browse_collection;
    var displayStyle = (i === 0) ? 'display: block;' : 'display: none;';
    return '<section class="hb-section hb-sec-' + i + '" id="sec-' + key + '" style="' + displayStyle + '">'
      + '<div class="hb-acc-head">'
      + '<div class="hb-acc-left">'
      + '<div><p class="hb-acc-title">' + cat.name + '</p>'
      + '<p class="hb-acc-hint">' + ALC_STRINGS.explore_select + '</p></div>'
      + '</div>'
      + '<div class="hb-acc-right">'
      + '<span class="hb-pill' + (selCount > 0 ? ' done' : '') + '" id="pill-' + key + '">' + pillText + '</span>'
      + '</div>'
      + '</div>'
      + '<div class="hb-acc-body"><div class="hb-acc-inner">' + groupsHTML(groups, key, cat.name) + '</div></div>'
      + '</section>';
  }

  function rerenderCat(i){
    var key = "c" + i;
    var cat = ALC_CONFIG.categories[i];
    var selCount = Object.values(selectedItems).filter(function(item) { return mine(item) && item.catKey === key; }).reduce(function(sum, item) { return sum + item.quantity; }, 0);
    var pill = getEl("pill-" + key);
    if (pill) {
      pill.textContent = selCount > 0 ? selCount + " " + ALC_STRINGS.items_selected : ALC_STRINGS.browse_collection;
      pill.className = "hb-pill" + (selCount > 0 ? " done" : "");
    }
    var sec = getEl("sec-" + key);
    if (sec && catGroups[key]) {
      var inner = sec.querySelector(".hb-acc-inner");
      if(inner){
        inner.innerHTML = groupsHTML(catGroups[key], key, cat.name);
      }
    }
  }

  window.switchTab = function(index) {
    currentTabIndex = index;
    var tabs = document.querySelectorAll(".hb-tab");
    tabs.forEach(function(tab, i) {
      if (i === index) { tab.classList.add("hb-tab-active"); tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); }
      else { tab.classList.remove("hb-tab-active"); }
    });
    var sections = document.querySelectorAll(".hb-section");
    sections.forEach(function(sec, i) {
      sec.style.display = (i === index) ? "block" : "none";
    });
    var stickyWrap = getEl("hb-sticky-wrap");
    var offset = stickyWrap ? stickyWrap.offsetHeight : 0;
    var container = getEl("hb-categories");
    if(container){
      var rect = container.getBoundingClientRect();
      if (rect.top < offset) {
        window.scrollTo({ top: container.offsetTop - offset - 20, behavior: "smooth" });
      }
    }
  };

  window.openDrawerSelection = function(key){
    var d = getEl("hb-drawer");
    if (d && d.classList.contains("hb-open")) {
      d.classList.remove("hb-open");
      document.body.style.overflow = "";
      var exp = getEl("hb-bar-expand");
      if (exp) exp.innerHTML = "&#8593;";
    }
    var catI = parseInt(key.replace("c", ""), 10);
    window.switchTab(catI);
  };

  function showToast(msg, type){
    var t = getEl("hb-toast");
    if (!t) return;
    t.textContent = msg;
    t.className = "hb-toast hb-toast-show"
      + (type === "success" ? " hb-toast-success" : "")
      + (type === "error" ? " hb-toast-error" : "");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ t.className = "hb-toast"; }, 2600);
  }

  window.changeLbQty = function(delta) {
    var newQty = lbCurrentQty + delta;
    if (newQty < 1) {
      if (lbCard && selectedItems[lbCard.dataset.variant]) { window.removeCurrentLBItem(); }
      else { lbCurrentQty = 1; getEl("hb-lb-qty-val").textContent = lbCurrentQty; }
      return;
    }
    if (newQty > lbMaxQty) { showToast(ALC_STRINGS.stock_limit_toast.replace('{qty}', lbMaxQty), "error"); return; }
    lbCurrentQty = newQty;
    getEl("hb-lb-qty-val").textContent = lbCurrentQty;
  };

  window.updateItemQty = function(vId, delta) {
    var item = selectedItems[vId];
    if (!item) return;
    var newQty = item.quantity + delta;
    if (newQty < 1) { window.unselectItem(vId); return; }
    var maxNow = variantStock({ id: vId, available: true }).maxQty; /* live: gift sets may use some */
    if (newQty > maxNow) { showToast(ALC_STRINGS.stock_limit_toast.replace('{qty}', maxNow), "error"); return; }
    item.quantity = newQty;
    saveCart();
    var catI = parseInt(item.catKey.replace("c", ""), 10);
    rerenderCat(catI);
    updateAll();
    buildDrawer();
  };

  window.openLB = function(card){
    lbCard = card;
    try { lbImages = JSON.parse(decodeURIComponent(card.dataset.images || "[]")); }
    catch (e) { lbImages = [card.dataset.thumb]; }
    if (!lbImages.length) lbImages = [card.dataset.thumb];
    window.setLBImg(0);
    getEl("hb-lb-cat").textContent = card.dataset.catname;
    getEl("hb-lb-name").textContent = card.dataset.name;
    getEl("hb-lb-price").textContent = "AED " + card.dataset.price;
    var descEl = getEl("hb-lb-desc");
    if (descEl) descEl.textContent = card.dataset.desc || "";

    /* size picker — only for products that have size variants in Shopify */
    try { lbSizes = JSON.parse(decodeURIComponent(card.dataset.sizes || "[]")); } catch (e) { lbSizes = []; }
    lbSize = null;
    if (lbSizes.length) {
      /* if one of this product's sizes is already in the selection, start from it */
      lbSize = lbSizes.filter(function(sz){ return !!selectedItems[sz.id]; })[0] || null;
    }
    if (!lbSize) lbSize = gbOnlySize();
    refreshLB();
    getEl("hb-lb").classList.add("hb-lb-open");
    document.body.style.overflow = "hidden";
  };

  /* The variant the lightbox is currently acting on: the chosen size, or the product's only variant. */
  function lbVariant(){
    if (!lbCard) return null;
    if (lbSizes.length) {
      if (!lbSize) return null;
      return { id: lbSize.id, price: lbSize.price, maxQty: lbSize.maxQty, oos: !lbSize.available, size: lbSize.title };
    }
    return { id: lbCard.dataset.variant, price: lbCard.dataset.price, maxQty: parseInt(lbCard.dataset.maxqty, 10) || 999,
             oos: lbCard.classList.contains("hb-oos"), size: "" };
  }

  /* 2026-10-15: when only ONE size is in stock (sold-out sizes don't count), pick it automatically
     and just show "Size: X" instead of asking the customer to choose. */
  function gbOnlySize(){
    var av = lbSizes.filter(function(sz){ return sz.available; });
    return av.length === 1 ? av[0] : null;
  }
  function gbOnlySizeLabel(sz){
    return escHTML(ALC_STRINGS.size_label) + ': <span style="text-transform:none;letter-spacing:.02em;color:var(--text);font-size:1.15em;margin-inline-start:4px">' + escHTML(sz.title) + '</span>';
  }
  function renderLBSizes(){
    var wrap = getEl("hb-lb-sizes"), chips = getEl("hb-size-chips"), lbl = getEl("hb-lb-size-label");
    if (!wrap || !chips) return;
    if (!lbSizes.length) { wrap.style.display = "none"; chips.innerHTML = ""; return; }
    wrap.style.display = "";
    var only = gbOnlySize();
    if (only && (!lbSize || String(lbSize.id) === String(only.id))) { if (lbl) lbl.innerHTML = gbOnlySizeLabel(only); chips.innerHTML = ""; return; }
    if (lbl) lbl.textContent = lbSize ? ALC_STRINGS.size_label : ALC_STRINGS.choose_size;
    chips.innerHTML = lbSizes.map(function(sz, i){
      var cls = "hb-size-chip" + (lbSize && lbSize.id === sz.id ? " active" : "") + (sz.available ? "" : " hb-size-chip-oos") + (selectedItems[sz.id] ? " hb-size-chip-in" : "");
      return '<button type="button" class="' + cls + '"' + (sz.available ? '' : ' disabled') + ' onclick="window.pickLBSize(' + i + ')">' + escHTML(sz.title) + '</button>';
    }).join("");
  }

  window.pickLBSize = function(i){
    var sz = lbSizes[i];
    if (!sz || !sz.available) return;
    lbSize = sz;
    refreshLB();
  };

  /* Re-sync price, qty, and the buttons to the active variant (called on open and after a size tap). */
  function refreshLB(){
    if (!lbCard) return;
    renderLBSizes();
    var cur = lbVariant();
    var pick = getEl("hb-lb-pick");
    var removeBtn = getEl("hb-lb-remove");
    var qtyWrap = getEl("hb-lb-qty-wrapper");
    var priceEl = getEl("hb-lb-price");
    var already = !!(cur && selectedItems[cur.id]);
    var isOos = cur ? cur.oos : lbCard.classList.contains("hb-oos");

    if (priceEl) priceEl.textContent = "AED " + (cur ? cur.price : lbCard.dataset.price);
    lbMaxQty = cur ? cur.maxQty : 999;
    lbCurrentQty = already ? selectedItems[cur.id].quantity : 1;
    if (lbCurrentQty > lbMaxQty) lbCurrentQty = lbMaxQty;
    if (lbCurrentQty < 1) lbCurrentQty = 1;
    getEl("hb-lb-qty-val").textContent = lbCurrentQty;

    pick.classList.remove("hb-lb-pick-remove");
    if (isOos) {
      pick.textContent = ALC_STRINGS.out_of_stock; pick.disabled = true;
      pick.style.opacity = "0.5"; pick.style.cursor = "not-allowed";
      pick.onclick = null; qtyWrap.style.display = "none"; removeBtn.style.display = "none";
    } else if (!cur) {
      /* sizes exist but none chosen yet */
      qtyWrap.style.display = "none"; pick.disabled = false;
      pick.style.opacity = ""; pick.style.cursor = "";
      pick.textContent = ALC_STRINGS.add_to_selection;
      pick.onclick = selectFromLB;
      removeBtn.style.display = "none";
    } else {
      qtyWrap.style.display = "flex"; pick.disabled = false;
      pick.style.opacity = ""; pick.style.cursor = "";
      if (already) {
        pick.textContent = ALC_STRINGS.update_selection;
        pick.onclick = selectFromLB;
        removeBtn.textContent = ALC_STRINGS.remove_selection;
        removeBtn.style.display = "block";
      }
      else {
        pick.textContent = ALC_STRINGS.add_to_selection;
        pick.onclick = selectFromLB;
        removeBtn.style.display = "none";
      }
    }
  }

  window.removeCurrentLBItem = function() {
    var cur = lbVariant();
    if (cur && selectedItems[cur.id]) { window.unselectItem(cur.id); window.closeLB(); }
  };

  window.setLBImg = function(i){
    getEl("hb-lb-img").src = lbImages[i];
    getEl("hb-lb-thumbs").innerHTML = lbImages.map(function(src, j){
      return '<button type="button" class="hb-thumb' + (j === i ? ' active' : '') + '" onclick="window.setLBImg(' + j + ')"><img src="' + imgW(src, 200) + '" alt="" width="100" height="100"></button>';
    }).join("");
  };

  window.closeLB = function(){
    getEl("hb-lb").classList.remove("hb-lb-open");
    document.body.style.overflow = "";
    lbCard = null; lbImages = []; lbSizes = []; lbSize = null;
  };

  function selectFromLB(){
    if (!lbCard) return;
    var cur = lbVariant();
    if (!cur) {
      showToast(ALC_STRINGS.size_required, "error");
      var chips = getEl("hb-size-chips"); if (chips) { chips.classList.remove("hb-shake"); void chips.offsetWidth; chips.classList.add("hb-shake"); }
      return;
    }
    var key = lbCard.dataset.cat;
    var vId = cur.id;
    var name = lbCard.dataset.name;
    var price = parseFloat(cur.price);
    var catI = parseInt(key.replace("c", ""), 10);
    selectedItems[vId] = {
      catKey: key, variantId: vId, productId: lbCard.dataset.product, handle: lbCard.dataset.handle, name: name, size: cur.size, price: price,
      catName: lbCard.dataset.catname, img: lbCard.dataset.thumb,
      quantity: lbCurrentQty, maxQty: lbMaxQty, stock: rawStock(vId), src: PAGE_SRC, url: location.pathname
    };
    saveCart();
    window.closeLB();
    rerenderCat(catI);
    updateAll();
    showToast(displayName(selectedItems[vId]) + " " + ALC_STRINGS.added_toast, "success");
  }

  window.unselectItem = function(vId){
    if(!selectedItems[vId]) return;
    var catKey = selectedItems[vId].catKey;
    var catI = parseInt(catKey.replace("c", ""), 10);
    delete selectedItems[vId];
    saveCart();
    rerenderCat(catI);
    updateAll();
    buildDrawer();
    showToast(ALC_STRINGS.removed_toast);
  };

  function buildTabs(){
    var el = getEl("hb-tabs");
    if (!el) return;
    el.innerHTML = ALC_CONFIG.categories.map(function(c, i){
      var key = "c" + i;
      var selCount = Object.values(selectedItems).filter(function(item) { return mine(item) && item.catKey === key; }).reduce(function(sum, item) { return sum + item.quantity; }, 0);
      var cls = "hb-tab" + (selCount > 0 ? " hb-tab-done" : "") + (i === currentTabIndex ? " hb-tab-active" : "");
      return '<button type="button" class="' + cls + '" onclick="window.switchTab(' + i + ')">' + (selCount > 0 ? '&#10003; ' : '') + c.name + '</button>';
    }).join("");
  }

  /* 2026-10-22: gift sets from the other pages, shown in this page's basket list (panel: "pi", phone drawer: "di").
     Tapping one opens the shared cart; ✕ removes it from the cart. */
  function setsHTML(p){
    return GBCart.sets().map(function(s){
      return '<div class="hb-' + p + '-wrap">'
        + '<div class="hb-' + p + (p === 'pi' ? ' hb-pi-filled' : '') + '">'
        + '<button type="button" class="hb-' + p + '-main" onclick="GBCart.open()">'
        + (s.img ? '<img class="hb-' + p + '-img" src="' + esc(s.img) + '" alt="" width="80" height="80">' : '')
        + '<div class="hb-' + p + '-info">'
        + '<p class="hb-pi-cat">' + escHTML(GBCart.t.gift_set) + '</p>'
        + '<p class="hb-pi-name">' + escHTML(s.name) + '</p>'
        + '<p class="hb-pi-size">' + escHTML(GBCart.t.picks.replace('{n}', s.picks.length)) + '</p>'
        + '<p style="color:var(--green); font-size:calc(.9 * var(--gb-rem)); font-weight:700; margin-top:2px;">AED ' + formatPrice(s.price) + '</p>'
        + '</div>'
        + '</button>'
        + (p === 'pi'
            ? '<button type="button" class="hb-pi-rm" onclick="GBCart.removeLine(\'' + s.id + '\')">&#10005;</button>'
            : '<div class="hb-di-actions"><button type="button" class="hb-di-rm" onclick="GBCart.removeLine(\'' + s.id + '\')">&#10005;</button></div>')
        + '</div>'
        + '</div>';
    }).join("");
  }
  /* Tapping a piece from THIS page jumps to its category; pieces from other pages open the shared cart. */
  function itemClick(sel){
    return mine(sel) ? 'window.openDrawerSelection(\'' + sel.catKey + '\')' : 'GBCart.open()';
  }
  function deliveryNoteHTML(){
    var note = GBCart.deliveryNote();
    return { cls: note.free ? "hb-nudge-success" : "hb-nudge-info",
             html: '<span class="hb-nudge-icon">' + (note.free ? '✓' : '🚚') + '</span> ' + escHTML(note.text) };
  }

  function buildPanel(){
    var itemsArr = Object.values(selectedItems);
    var totalItems = getTotalItemsCount();
    var subtotal = getSubtotal();
    var delivery = getDeliveryCharge(subtotal);
    var grandTotal = subtotal + delivery;

    var sub = getEl("hb-panel-sub");
    if (sub) {
      if(totalItems > 0) {
        sub.textContent = totalItems + " " + ALC_STRINGS.items_selected;
      } else {
        sub.textContent = "0 " + ALC_STRINGS.items_selected;
      }
    }

    var iHTML = itemsArr.map(function(sel){
      return '<div class="hb-pi-wrap">'
        + '<div class="hb-pi hb-pi-filled">'
        + '<button type="button" class="hb-pi-main" onclick="' + itemClick(sel) + '">'
        + '<img class="hb-pi-img" src="' + sel.img + '" alt="" width="80" height="80">'
        + '<div class="hb-pi-info">'
        + '<p class="hb-pi-cat">' + sel.catName + '</p>'
        + '<p class="hb-pi-name">' + sel.name + '</p>'
        + (sel.size ? '<p class="hb-pi-size">' + ALC_STRINGS.size_label + ': ' + escHTML(sel.size) + '</p>' : '')
        + '<p style="color:var(--green); font-size:calc(.9 * var(--gb-rem)); font-weight:700; margin-top:2px;">AED ' + formatPrice(sel.price * sel.quantity) + '</p>'
        + '<div class="hb-pi-qty-ctrl">'
        + '<div onclick="event.stopPropagation(); window.updateItemQty(\'' + sel.variantId + '\', -1)">-</div>'
        + '<span>' + sel.quantity + '</span>'
        + '<div onclick="event.stopPropagation(); window.updateItemQty(\'' + sel.variantId + '\', 1)">+</div>'
        + '</div>'
        + '</div>'
        + '</button>'
        + '<button type="button" class="hb-pi-rm" onclick="window.unselectItem(\'' + sel.variantId + '\')">&#10005;</button>'
        + '</div>'
        + '</div>';
    }).join("") + setsHTML('pi');

    if (totalItems === 0) {
      iHTML = '<p class="hb-empty" style="text-align:center; padding: 20px 0;">' + ALC_STRINGS.empty_selection + '</p>';
    }

    var el = getEl("hb-panel-items");
    if (el) el.innerHTML = iHTML;

    var subDisplay = getEl("hb-subtotal-display");
    if (subDisplay) subDisplay.textContent = "AED " + formatPrice(subtotal);

    var deliveryRow = getEl("hb-delivery-row");
    var deliveryAmount = getEl("hb-delivery-amount");
    if (deliveryRow && deliveryAmount) {
      if (totalItems === 0) {
        deliveryRow.style.display = "none";
      } else {
        deliveryRow.style.display = "flex";
        if (delivery === 0) {
          deliveryAmount.textContent = ALC_STRINGS.free;
          deliveryAmount.style.color = "var(--green)";
          deliveryAmount.style.fontWeight = "800";
          deliveryRow.classList.add("hb-delivery-free");
        } else {
          deliveryAmount.textContent = "AED " + formatPrice(delivery);
          deliveryAmount.style.color = "";
          deliveryAmount.style.fontWeight = "";
          deliveryRow.classList.remove("hb-delivery-free");
        }
      }
    }

    var gtEl = getEl("hb-grand-total");
    if (gtEl) gtEl.textContent = "AED " + formatPrice(grandTotal);

    var nudge = getEl("hb-delivery-nudge");
    if (nudge) {
      var note = deliveryNoteHTML();
      nudge.innerHTML = note.html;
      nudge.className = "hb-delivery-nudge " + note.cls;
    }

    var cta = getEl("hb-panel-cta"), ctaTxt = getEl("hb-panel-cta-text");
    if (cta && ctaTxt) {
      cta.disabled = totalItems === 0;
      ctaTxt.textContent = totalItems > 0 ? GB_LIQ.t_cta_purchase + " — AED " + formatPrice(grandTotal) : GB_LIQ.t_cta_select_items;
      cta.onclick = totalItems > 0 ? window.processCheckout : null;
    }
  }

  function buildBar(){
    var totalItems = getTotalItemsCount();
    var grandTotal = GBCart.totals().total;

    var tEl = getEl("hb-bar-total");
    var cEl = getEl("hb-bar-count");
    var bTotal = getEl("hb-banner-total");
    if(tEl) tEl.textContent = "AED " + formatPrice(grandTotal);
    if(cEl) {
      if (totalItems > 0) {
         cEl.textContent = totalItems + " " + ALC_STRINGS.items_selected;
      } else {
         cEl.textContent = "0 " + ALC_STRINGS.items_selected;
      }
    }
    if(bTotal) bTotal.textContent = "AED " + formatPrice(grandTotal);

    var cta = getEl("hb-bar-cta"), txt = getEl("hb-bar-cta-txt");
    var banner = getEl("hb-purchase-banner");
    var bar = getEl("hb-bar");
    if (cta && txt) {
      cta.disabled = totalItems === 0;
      if (totalItems > 0) {
        txt.textContent = GB_LIQ.t_drawer_view;
        cta.onclick = window.toggleDrawer;
        cta.classList.add("hb-bar-cta-ready");
        if (banner && window.innerWidth <= 960) { banner.style.display = "block"; bar.style.display = "none"; }
      } else {
        txt.textContent = GB_LIQ.t_cta_select_mobile;
        cta.onclick = null;
        cta.classList.remove("hb-bar-cta-ready");
        if (banner) { banner.style.display = "none"; if(window.innerWidth<=960) bar.style.display = "flex"; }
      }
    }
  }

  function buildDrawer(){
    var itemsArr = Object.values(selectedItems);
    var totalItems = getTotalItemsCount();
    var subtotal = getSubtotal();
    var delivery = getDeliveryCharge(subtotal);
    var grandTotal = subtotal + delivery;

    var iHTML = itemsArr.map(function(sel){
      return '<div class="hb-di-wrap">'
        + '<div class="hb-di">'
        + '<button type="button" class="hb-di-main" onclick="' + itemClick(sel) + '">'
        + '<img class="hb-di-img" src="' + sel.img + '" alt="" width="80" height="80">'
        + '<div class="hb-di-info">'
        + '<p class="hb-pi-cat">' + sel.catName + '</p>'
        + '<p class="hb-pi-name">' + sel.name + '</p>'
        + (sel.size ? '<p class="hb-pi-size">' + ALC_STRINGS.size_label + ': ' + escHTML(sel.size) + '</p>' : '')
        + '<p style="color:var(--green); font-size:calc(.9 * var(--gb-rem)); font-weight:700; margin-top:2px;">AED ' + formatPrice(sel.price * sel.quantity) + '</p>'
        + '<div class="hb-pi-qty-ctrl">'
        + '<div onclick="event.stopPropagation(); window.updateItemQty(\'' + sel.variantId + '\', -1)">-</div>'
        + '<span>' + sel.quantity + '</span>'
        + '<div onclick="event.stopPropagation(); window.updateItemQty(\'' + sel.variantId + '\', 1)">+</div>'
        + '</div>'
        + '</div>'
        + '</button>'
        + '<div class="hb-di-actions">'
        + '<button type="button" class="hb-di-rm" onclick="window.unselectItem(\'' + sel.variantId + '\')">&#10005;</button>'
        + '</div>'
        + '</div>'
        + '</div>';
    }).join("") + setsHTML('di');

    if (totalItems === 0) {
      iHTML = '<p class="hb-empty" style="text-align:center; padding: 20px 0;">' + ALC_STRINGS.empty_selection + '</p>';
    }

    var el = getEl("hb-drawer-items");
    if (el) el.innerHTML = iHTML;

    // Fixed nudge for the drawer to always show delivery status
    var note = deliveryNoteHTML();
    var nudgeHTML = '<div class="hb-drawer-nudge ' + note.cls + '">' + note.html + '</div>';

    var tHTML = nudgeHTML
      + '<div class="hb-tl"><span>' + GB_LIQ.t_subtotal + '</span><span>AED ' + formatPrice(subtotal) + '</span></div>'
      + '<div class="hb-tl">'
      + '<span>' + GB_LIQ.t_delivery + '</span>'
      + (delivery === 0 && totalItems > 0
          ? '<span style="color:var(--green); font-weight:800;">' + ALC_STRINGS.free + '</span>'
          : '<span>' + (totalItems === 0 ? '—' : 'AED ' + formatPrice(delivery)) + '</span>')
      + '</div>'
      + '<div class="hb-tl hb-tl-grand"><span>' + GB_LIQ.t_total + '</span><span>AED ' + formatPrice(grandTotal) + '</span></div>';

    tHTML += totalItems > 0
      ? '<button class="hb-mdr-cta" onclick="window.processCheckout()">' + GB_LIQ.t_cta_purchase + ' — AED ' + formatPrice(grandTotal) + '</button>'
      : '<button class="hb-mdr-cta hb-mdr-cta-dim" disabled>' + GB_LIQ.t_cta_select_items + '</button>';

    var tel = getEl("hb-drawer-totals");
    if (tel) tel.innerHTML = tHTML;
  }

  window.toggleDrawer = function(){
    var d = getEl("hb-drawer"), btn = getEl("hb-bar-expand");
    var open = d.classList.contains("hb-open");
    if (open) {
      d.classList.remove("hb-open"); document.body.style.overflow = "";
      if (btn) btn.innerHTML = "&#8593;";
    } else {
      buildDrawer(); d.classList.add("hb-open"); document.body.style.overflow = "hidden";
      if (btn) btn.innerHTML = "&#8595;";
    }
  };

  /* 2026-10-22: checkout happens in the shared cart (card or cash on delivery, the whole cart in one order). */
  window.processCheckout = function(){
    var d = getEl("hb-drawer");
    if (d && d.classList.contains("hb-open")) window.toggleDrawer();
    GBCart.checkout();
  };

  function updateAll(){ buildTabs(); buildPanel(); buildBar(); gbSyncClear(); }

  /* The cart was changed somewhere else (the cart window, another page in another tab, a gift set added):
     re-read it and redraw. After this page's own changes only the totals need redrawing. */
  /* 2026-10-22: any change in the cart (also gift sets) can change what's left in stock, so the cards are redrawn */
  var lastSig = "";
  function cartSig(){ return GBCart.lines().map(function(l){ return l.id + ":" + (l.quantity || 1); }).join("|"); }
  GBCart.onChange(function(){
    selectedItems = GBCart.pieceMap();
    var sig = cartSig();
    if (sig !== lastSig) { lastSig = sig; ALC_CONFIG.categories.forEach(function(c, i){ if (catGroups["c" + i]) rerenderCat(i); }); }
    updateAll();
    var d = getEl("hb-drawer");
    if (d && d.classList.contains("hb-open")) buildDrawer();
  });

  /* ── 2026-10-15: "Clear selection" ──
     A button under the selected items (side panel + phone drawer), shown only when something is selected.
     It asks "Start again?" in a small on-page box (not a browser pop-up), then empties the selection
     and the copy saved in this browser (gb_alc_cart_v9). */
  function gbSyncClear(){
    var show = getTotalItemsCount() > 0; /* 2026-10-22: the list is the shared cart */
    ["hb-panel-items", "hb-drawer-items"].forEach(function(id){
      var list = getEl(id); if (!list) return;
      var wrap = getEl(id + "-clear");
      if (!wrap) {
        wrap = document.createElement("div"); wrap.id = id + "-clear"; wrap.className = "hb-clear-wrap";
        wrap.innerHTML = '<button type="button" class="hb-clear-btn" onclick="window.gbAskClear()"><span class="hb-clear-icon" aria-hidden="true">&#8634;</span>' + escHTML(ALC_STRINGS.clear_btn) + '</button>';
        list.parentNode.insertBefore(wrap, list.nextSibling);
      }
      wrap.hidden = !show;
    });
  }
  window.gbAskClear = function(){
    if (!getTotalItemsCount()) return;
    var box = getEl("hb-confirm");
    if (!box) {
      box = document.createElement("div"); box.id = "hb-confirm"; box.className = "hb-confirm";
      box.setAttribute("role", "dialog"); box.setAttribute("aria-modal", "true"); box.setAttribute("aria-labelledby", "hb-confirm-title");
      box.innerHTML = '<div class="hb-confirm-overlay" onclick="window.gbCloseClear()"></div><div class="hb-confirm-card">'
        + '<div class="hb-confirm-icon" aria-hidden="true">&#8634;</div>'
        + '<p class="hb-confirm-title" id="hb-confirm-title">' + escHTML(ALC_STRINGS.clear_title) + '</p>'
        + '<p class="hb-confirm-text">' + escHTML(ALC_STRINGS.clear_text) + '</p>'
        + '<div class="hb-confirm-actions"><button type="button" class="hb-confirm-no" onclick="window.gbCloseClear()">' + escHTML(ALC_STRINGS.clear_no) + '</button>'
        + '<button type="button" class="hb-confirm-yes" onclick="window.gbConfirmClear()">' + escHTML(ALC_STRINGS.clear_yes) + '</button></div></div>';
      (getEl("hb-root") || document.body).appendChild(box);
    }
    box.hidden = false;
    var no = box.querySelector(".hb-confirm-no"); if (no) no.focus();
  };
  window.gbCloseClear = function(){ var box = getEl("hb-confirm"); if (box) box.hidden = true; };
  window.gbConfirmClear = function(){
    window.gbCloseClear();
    selectedItems = {};
    GBCart.clear();
    ALC_CONFIG.categories.forEach(function(c, i){ if (catGroups["c" + i]) rerenderCat(i); });
    updateAll(); buildDrawer(); showToast(ALC_STRINGS.clear_done);
  };
  document.addEventListener("keydown", function(e){ if (e.key === "Escape") window.gbCloseClear(); });

  function init(){
    var container = getEl("hb-categories");
    if (!container) return;
    GB_LOADING.then(function(results){
      var activeCats = [], activeGroups = [];
      results.forEach(function(groups, i) {
        var nonEmpty = (groups || []).filter(function(g){ return g.products && g.products.length > 0; });
        if (nonEmpty.length > 0) { activeCats.push(ALC_CONFIG.categories[i]); activeGroups.push(nonEmpty); }
      });
      if (activeCats.length === 0) {
        container.innerHTML = "<p style='padding:40px;color:#8a7a66;text-align:center;font-size:calc(1 * var(--gb-rem));'>" + ALC_STRINGS.no_products + "</p>";
        return;
      }
      ALC_CONFIG.categories = activeCats;
      var liveData = {};
      activeGroups.forEach(function(grps) {
        grps.forEach(function(g) {
          g.products.forEach(function(prod) {
            (prod.variants || []).forEach(function(v) {
              var st = variantStock(v);
              liveData[v.id] = { price: parseFloat(v.price), maxQty: st.maxQty, outOfStock: st.outOfStock, handle: prod.handle };
            });
          });
        });
      });
      var cartChanged = false, outOfStockRemoved = false, qtyReduced = false;
      Object.keys(selectedItems).forEach(function(vId) {
        var live = liveData[vId];
        if (live) {
          if (selectedItems[vId].price !== live.price) { selectedItems[vId].price = live.price; cartChanged = true; }
          /* pieces from the old basket have no handle; the shared cart needs it for its stock check */
          if (live.handle && !selectedItems[vId].handle) { selectedItems[vId].handle = live.handle; cartChanged = true; }
          if (live.outOfStock) { delete selectedItems[vId]; cartChanged = true; outOfStockRemoved = true; }
          else if (selectedItems[vId].quantity > live.maxQty) {
            selectedItems[vId].quantity = live.maxQty; selectedItems[vId].maxQty = live.maxQty;
            cartChanged = true; qtyReduced = true;
          } else { selectedItems[vId].maxQty = live.maxQty; }
        } else if (mine(selectedItems[vId])) { delete selectedItems[vId]; cartChanged = true; outOfStockRemoved = true; }
        /* pieces added on other pages that this page doesn't sell are left alone */
      });
      if (cartChanged) {
        saveCart();
        if (outOfStockRemoved) setTimeout(function(){ showToast(ALC_STRINGS.oos_removed_toast, "error"); }, 500);
        else if (qtyReduced) setTimeout(function(){ showToast(ALC_STRINGS.qty_reduced_toast, "error"); }, 500);
      }
      ALC_CONFIG.categories.forEach(function(c, i){ catGroups["c" + i] = activeGroups[i]; });
      container.innerHTML = ALC_CONFIG.categories.map(function(c, i){ return sectionHTML(c, activeGroups[i], i); }).join("");
      Object.values(selectedItems).forEach(function(item) {
        if (!mine(item)) return;
        var catI = parseInt(item.catKey.replace("c", ""), 10);
        rerenderCat(catI);
      });
      lastSig = cartSig();
      updateAll();
    }).catch(function(){
      container.innerHTML = "<p style='padding:40px;color:#8a7a66;font-size:calc(1 * var(--gb-rem));text-align:center;'>" + ALC_STRINGS.error_checkout + "</p>";
    });
  }

  document.addEventListener("keydown", function(e){ if (e.key === "Escape") window.closeLB(); });
  init();
})();


/* ════════════════════════════════════════════════════════════════════════
   A LITTLE CHRISTMAS extras: falling snow, hero photos, days-to-Christmas
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  var getEl = function(id){ return document.getElementById(id); };
  var calm = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Soft falling snow in the hero and the "coming soon" box */
  function snow(id, count){
    var box = getEl(id);
    if (!box || calm) return;
    var flakes = ["❄", "❅", "•", "✦", "•"], html = "";
    for (var i = 0; i < count; i++) {
      var size = 6 + Math.random() * 12;
      html += '<span class="xm-flake" style="left:' + (Math.random() * 100).toFixed(1) + '%;'
        + 'font-size:' + size.toFixed(0) + 'px;opacity:' + (0.35 + Math.random() * 0.5).toFixed(2) + ';'
        + 'animation-duration:' + (9 + Math.random() * 10).toFixed(1) + 's;'
        + 'animation-delay:-' + (Math.random() * 18).toFixed(1) + 's">'
        + flakes[i % flakes.length] + '</span>';
    }
    box.innerHTML = html;
  }
  var small = window.innerWidth < 700;
  snow("xm-snow", small ? 16 : 30);
  snow("xm-snow-2", small ? 10 : 18);

  /* Days until 25 December (hidden from 26 December) */
  var now = new Date();
  var xmas = new Date(now.getFullYear(), 11, 25);
  var days = Math.ceil((xmas - new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000);
  if (days >= 1 && getEl("xm-count")) {
    getEl("xm-count-num").textContent = days;
    getEl("xm-count").hidden = false;
  }

  /* Hero photos = the first 3 products of the collection (their main photo) */
  function sized(src, w){
    if (!src) return "";
    return src + (src.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
  }
  if (typeof GB_LOADING !== "undefined") {
    GB_LOADING.then(function(results){
      var list = [];
      (results || []).forEach(function(groups){
        (groups || []).forEach(function(g){ (g.products || []).forEach(function(p){ list.push(p); }); });
      });
      list = list.filter(function(p){ return p.images && p.images.length; });
      var order = [0, 1, 2]; /* frame 1 = big middle photo */
      order.forEach(function(n){
        var p = list[n], img = getEl("xm-ph-" + (n + 1));
        if (!p || !img) return;
        img.src = sized(p.images[0].src, n === 0 ? 700 : 450);
        img.alt = p.title || "";
        img.onload = function(){ img.hidden = false; };
      });
    });
  }
})();
